"use client";

import { ArrowRight, BadgeCheck, Headphones, IdCard } from "@/components/icons";
import ProductHeroRibbon from "@/components/sections/products/shared/hero-ribbon";
import { ROUTES, STATS } from "@/lib/constants";

/* The money-back guarantee rides in the benefit row rather than a second row of
   pills, so the hero keeps one line of trust signals like the homepage does. */
const benefits = [
  { label: "KYC required", icon: IdCard },
  { label: "30-day money-back guarantee", icon: BadgeCheck },
  { label: "Premium support", icon: Headphones },
];

export default function ResidentialProductHero() {
  return (
    <ProductHeroRibbon
      headingId="residential-product-hero-heading"
      headingLine1="Residential Proxies"
      headingLine2={`Across ${STATS.countries} Countries`}
      description={`Access ${STATS.ips.toLowerCase()} ethically sourced residential IPs across ${STATS.countries} countries. Target by country, city, or ISP, with rotating or sticky sessions, from $25/month.`}
      benefits={benefits}
      ctas={[
        {
          label: "View Residential Plans",
          href: ROUTES.pricingResidentialProxies,
          trailingIcon: <ArrowRight size={16} aria-hidden="true" />,
        },
        { label: "Read the Setup Guide", href: "#residential-setup-guide-heading" },
      ]}
      announcement={{ href: "/tools/mcp-server", label: "Our MCP server is here" }}
    />
  );
}
